import { useTranslation } from "react-i18next";
import { ReactSliderProps } from "react-slider";
import { Spinner } from "spot-component-library/lib/components/basic/spinner/Spinner";
import { SPOTNotification } from "spot-component-library/lib/components/notification/SPOTNotification";
import { FormFieldProps } from "spot-component-library/src/components/form/spotInput/SPOTInput";
import { RateAgreementOptions } from "../../../types/RateAgreementOptions";
import { RateCalculationType } from "../../../types/RateAgreementTenantConfiguration";
import { RateData } from "../../../types/RateData";
import { RateCalculationDefault } from "./RateCalculationDefault";
import { RateCalculationNumberOfRatesOnly } from "./RateCalculationNumberOfRatesOnly";

export type RateCalculationRendererProps = {
    errors: FormFieldProps["errors"];
    isMaxRateAlerting: boolean;
    rateAgreementOptions: RateAgreementOptions;
    rateData: RateData;
    register: FormFieldProps["register"];
    onChangeRateAmount: ReactSliderProps["onChange"];
    onChangeRateNumber: ReactSliderProps["onChange"];
    onInputChange: FormFieldProps["onChange"];
};

export const RateCalculationRenderer: React.FC<RateCalculationRendererProps & { type?: RateCalculationType }> = (props) => {
    const { t } = useTranslation();

    switch (props.type) {
        case undefined:
            return <Spinner isLoading type={"page"} />;
        case RateCalculationType.RATE_AMOUNT_ONLY:
            return <RateCalculationNumberOfRatesOnly {...props} />;
        case RateCalculationType.DEFAULT:
            return <RateCalculationDefault {...props} />;
        default:
            return <SPOTNotification active type={"error"} text={t("APP_ROOT.ERROR.SERVER_MESSAGE_DEFAULT")} />;
    }
};
